import React from "react";
import { Col, Row } from "react-bootstrap";

// icns
import { ReactComponent as Doc } from "../../../../../Assets/Images/icn/doc.svg";
import { ReactComponent as GUsers } from "../../../../../Assets/Images/icn/GreenUsers.svg";
import { ReactComponent as PCalender } from "../../../../../Assets/Images/icn/PinkCalender.svg";
import { ReactComponent as ChatIcn } from "Assets/Images/icn/Chat.svg";

const ColorCards = ({
  completedForms,
  taggedClients,
  upcomingAppointments,
  unreadMessages,
  isChatEnabled,
}) => {
  return (
    <>
      <Row className="colorCards">
        <Col xl="4" sm="6" className="my-2">
          <div
            className="cardCstm p-3 h-100 d-flex align-items-center justify-content-between gap-10"
            style={{ background: "#39796f" }}
          >
            <div className="d-flex align-items-center gap-10">
              <div
                className="imgWrp d-flex align-items-center justify-content-center rounded-circle me-2"
                style={{ background: "#FFE8CA" }}
              >
                <Doc />
              </div>
              <p className="m-0 fw-sbold text-white fs-6">Newly Completed Forms</p>
            </div>
            <h4 className="count m-0 fw-bold" style={{ color: "#08415c" }}>
              {completedForms && completedForms.total_count}
            </h4>
          </div>
        </Col>
        {isChatEnabled && (
          <Col xl="4" sm="6" className="my-2">
            <div
              className="cardCstm p-3 h-100 d-flex align-items-center justify-content-between gap-10"
              style={{ background: "#fdc169" }}
            >
              <div className="d-flex align-items-center gap-10">
                <div
                  className="imgWrp d-flex align-items-center justify-content-center rounded-circle me-2"
                  style={{ background: "#ffe2e2c7" }}
                >
                  <ChatIcn
                    fill="none"
                    stroke="#f4694b"
                  />
                </div>
                <p className="m-0 fw-sbold text-white fs-6">Unread Messages</p>
              </div>
              <h4 className="count m-0 fw-bold" style={{ color: "#08415c" }}>
                { unreadMessages || 0 }
              </h4>
            </div>
          </Col>
        )}
        <Col xl="4" sm="6" className="my-2">
          <div
            className="cardCstm p-3 h-100 d-flex align-items-center justify-content-between gap-10"
            style={{ background: "#f4694b" }}
          >
            <div className="d-flex align-items-center gap-10">
              <div
                className="imgWrp d-flex align-items-center justify-content-center rounded-circle me-2"
                style={{ background: "#ebb3bd" }}
              >
                <PCalender />
              </div>
              <p className="m-0 fw-sbold text-white fs-6">Upcoming Appointments</p>
            </div>
            <h4 className="count m-0 fw-bold " style={{ color: "#08415c" }}>
              {upcomingAppointments && upcomingAppointments.total_count}
            </h4>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ColorCards;
